// extracted by mini-css-extract-plugin
export default {"modal":"StocksFilterForm_modal__Bg++o","slide-down":"StocksFilterForm_slide-down__rLOHP"};